import React from 'react'
// import authRoute from './authRoute'
import { ADMIN, USER, ANONYMOUS } from 'constants/roles.constant'
import { THEME_ENUM } from 'constants/theme.constant'

// export const publicRoutes = [...authRoute]
export const publicRoutes = []

export const protectedUserRoutes = [
    // {
    //     key: 'onboardingSearch',
    //     path: '/onboarding-search',
    //     component: React.lazy(() =>
    //         import('views/user/titleFeed/OnboardingSearch')
    //     ),
    //     authority: [USER, ANONYMOUS],
    // },
    {
        key: 'titleFeed',
        path: '/',
        component: React.lazy(() => import('views/user/titleFeed')),
        authority: [USER, ANONYMOUS],
    },
    {
        key: 'dashboard',
        path: '/dashboard/:activeTabKey?',
        component: React.lazy(() => import('views/user/Dashboard')),
        authority: [USER, ANONYMOUS],
    },
]

export const protectedAdminRoutes = [
    {
        key: 'dashboard',
        path: '/',
        component: React.lazy(() => import('views/admin/Home')),
        authority: [ADMIN],
        meta: {
            layout: THEME_ENUM.LAYOUT_TYPE_MODERN,
        },
    },
    {
        key: 'users',
        path: '/users',
        component: React.lazy(() => import('views/admin/Users')),
        authority: [ADMIN],
        meta: {
            layout: THEME_ENUM.LAYOUT_TYPE_MODERN,
        },
    },
    {
        key: 'packages',
        path: '/packages',
        component: React.lazy(() => import('views/admin/Packages')),
        authority: [ADMIN],
        meta: {
            layout: THEME_ENUM.LAYOUT_TYPE_MODERN,
        },
    },
    {
        key: 'memberships',
        path: '/memberships',
        component: React.lazy(() => import('views/admin/Memberships')),
        authority: [ADMIN],
        meta: {
            layout: THEME_ENUM.LAYOUT_TYPE_MODERN,
        },
    },
    {
        key: 'revBreak',
        path: '/revenue-breakdown',
        component: React.lazy(() => import('views/admin/RevBreak')),
        authority: [ADMIN],
        meta: {
            layout: THEME_ENUM.LAYOUT_TYPE_MODERN,
        },
    },
    {
        key: 'editTermsOfUse',
        path: '/editTermsOfUse',
        component: React.lazy(() => import('views/admin/EditTermsOfUse')),
        authority: [ADMIN],
        meta: {
            layout: THEME_ENUM.LAYOUT_TYPE_MODERN,
        },
    },
]
